import styles from './PreperResetPwdCardMobile.module.less'
import AInput from '@/components/A/AInput/AInput'
import AButton from '@/components/A/AButton/AButton'
import { useState } from 'react'
import { useRequest } from 'alova/client'
import { api } from '@/api'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import cls from 'classnames'
import { commonUtils } from '@/helpers/commonUtils'
import { FormItem } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import { useTranslation } from 'react-i18next'

function PreperResetPwdCardMobile() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const [sendSucceed, setSendSucceed] = useState(false)
  const [email, setEmail] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const { send, loading } = useRequest(api.auth.forgotPassword, {
    immediate: false,
  })

  const doSendEmail = async (email: string) => {
    const {
      data: { errorCode },
    } = await send({ email })
    if (errorCode === 40003) {
      setErrorMsg(t('resetPwdPage.message.requestLimit'))
    } else if (errorCode === 40002) {
      /** 这里鉴于会存在安全问题，可能会被别人枚举出我们的客户邮箱，
       * 因此这里不显示邮箱账号是否存在，并直接跳转到填写 code 页面。
       */
      // setErrorMsg(t('resetPwdPage.emailNotFound'))
      setErrorMsg('')
      setSendSucceed(true)
    } else {
      message.success(t('resetPwdPage.emailHasSent', { email }))
      setErrorMsg('')
      setSendSucceed(true)
    }
  }

  const handleForgotPassword = async () => {
    if (sendSucceed) {
      navigate(PAGE_LINKS.login)
    } else {
      doSendEmail(email)
    }
  }

  const handleTryAgain = () => {
    setErrorMsg('')
    setEmail('')
    setSendSucceed(false)
  }

  return (
    <div className={cls(styles.card, styles.preperResetPwdCard)}>
      <img
        className={styles.brand}
        src={commonUtils.getImagePath('loginPage/login-brand.png')}
        alt=''
      />
      <p className={styles.title}>
        {sendSucceed ? t('resetPwdPage.checkYourInbox') : t('resetPwdPage.resetYourPassword')}
      </p>
      <p className={styles.desc}>
        {sendSucceed ? t('resetPwdPage.resetLinkHasSent') : t('resetPwdPage.enterYourEmailAddress')}
      </p>
      {sendSucceed ? (
        <p className={styles.notGetEmail}>
          {t('resetPwdPage.didNotGetEmail')}
          <span className={styles.tryAgain} onClick={handleTryAgain} data-testid='reset-pwd-try-again-btn'>
            {t('resetPwdPage.tryAgain')}
          </span>
        </p>
      ) : (
        <div style={{ marginTop: 24 }}>
          <FormItem label={t('resetPwdPage.email')}
            labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
            error={Boolean(errorMsg)} errorMsg={errorMsg}
            errorMsgRender={(msg) => <span className={cls(styles.formItemErrorMsg, styles[i18n.language])}>{msg}</span>}
          >
            <AInput
              testId='reset-pwd-email-input'
              className={styles.inputWidth}
              placeholder={t('resetPwdPage.enterYourEmail')}
              onChange={(e) => {
                setEmail(e.target.value)
              }}
              onBlur={() => {
                window.scrollTo(0, 0)
              }}
            ></AInput>
          </FormItem>
        </div>
      )}
      <AButton
        testId='reset-pwd-send-email-btn'
        disabled={email === ''}
        loading={loading}
        type='primary'
        size='LG'
        className={styles.nextBtn}
        onClick={handleForgotPassword}
      >
        {sendSucceed ? t('resetPwdPage.goBackToSign') : t('resetPwdPage.resetPassword')}
      </AButton>
    </div>
  )
}

export default PreperResetPwdCardMobile
